import React from 'react';
import { connect } from 'react-redux';
import { reduxForm, Field } from 'redux-form';
import Hospitales from "./hospitales.cmpt";
import Medicos from "./medicos.cmpt";

const iconHospital = require("../img/hospital.svg");
const iconDoctor = require("../img/doctor.svg");

const mapState = (state) => {
    return {
        initialValues: { 'servicio' : 'hospitales' }
    };
}

const validate = (campos) => {
    const errors = {};
    if(!campos.servicio) {
        errors.servicio = 'Campo requerido.';
    }
    return errors;
}

class ServiciosForm extends React.Component {

    constructor() {
        super();
        this.state ={
            planes: [],
            clase: "",
            checked: true
        };
        this.handleChangeRadio = this.handleChangeRadio.bind(this);
    }

    handleChangeRadio() {
        this.setState({
            checked: !this.state.checked
        })

    }
    render () {
    	const { handleSubmit } = this.props;
    	const content = this.state.checked ? <Hospitales/> : <Medicos/>;
        return (
			<form id="formulario" onSubmit={handleSubmit}>
			    <h5>Buscar convenio por:</h5>
                <div className="input-wrap">
                    <div className="row">
                        <div className="col-sm-12 text-center">
                    <div className="row">
                        <div className="col-sm-6 col-xs-6 text-center">
                            <div className="checkbox-blue">
                                <div className="blu-input-radio">
                                    <Field name="servicio" component="input" type="radio" value="hospitales" onChange={this.handleChangeRadio} checked={this.state.checked}/>
                                    <label></label>
                                </div>
                                <img src={iconHospital}/><br/>Hospitales
                            </div>
                        </div>
                        <div className="col-sm-6 col-xs-6 text-center">
                            <div className="checkbox-blue">
                                <div className="blu-input-radio">
                                    <Field name="servicio" component="input" type="radio" value="medicos" onChange={this.handleChangeRadio}/>
                                    <label></label>
                                </div>
                                <img src={iconDoctor}/><br/>Médicos
                            </div>
                        </div>
                    </div>
                        </div>
                    </div>
                    <hr />
                    {content}
                </div>
			</form>
        )
    }
}

ServiciosForm = reduxForm({form: 'directorio-servicios', validate})(ServiciosForm);

export default connect(mapState, null)(ServiciosForm);



// WEBPACK FOOTER //
// ./src/directorio/servicios.frm.js